const config = {
  apiUrl: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_KEY_PROD : process.env.REACT_APP_API_KEY_DEV,

  commonUrl: process.env.REACT_APP_API_URL,
}

export { config as configuration }
